import Raven from 'raven-js';
import useComponentMountMetric from 'customer-data-properties/metrics/useComponentMountMetric';
import { computeFrequencyLabelAndDayName, iCalendarToRecurrenceConfig } from 'meetings-icalendar-utils-lib/utils/iCalendar';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedMeetingRecurrenceSchedule = ({
  value,
  placeholder,
  dataAttributes
}) => {
  useComponentMountMetric('FormattedMeetingRecurrenceSchedule');
  if (value === null || value === undefined || value === '') {
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: placeholder
    }));
  }
  let label = null;
  try {
    const recurrenceConfig = iCalendarToRecurrenceConfig({
      iCalendarString: value
    });
    label = computeFrequencyLabelAndDayName(recurrenceConfig);
  } catch (e) {
    Raven.captureMessage('Unable to compute Meeting Frequency label', {
      extra: {
        value,
        error: `${e}`
      }
    });
    label = placeholder;
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
    children: label
  }));
};
export default FormattedMeetingRecurrenceSchedule;